import { Button, Menu } from '@mantine/core';
import { FC, memo } from 'react';
import { Icon } from 'src/components/Icon';

import styles from './styles.module.css';
import { useUserMenu } from './use-user-menu';

export const UserMenu: FC = memo(() => {
  const { userName, menuItems } = useUserMenu();

  return (
    <Menu position="bottom-end" offset={10}>
      <Menu.Target>
        <Button className={styles.button}>
          <Icon className={styles.icon} name="accountCircle" />
        </Button>
      </Menu.Target>

      <Menu.Dropdown className={styles.dropdown}>
        <Menu.Label className={styles.dropdownLabel}>{userName}</Menu.Label>

        {menuItems.map(({ label, icon, action }) => (
          <Menu.Item
            className={styles.dropdownItem}
            onClick={action}
            key={label}
            leftSection={<Icon className={styles.dropdownIcon} name={icon} />}
          >
            {label}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
});
